import React from "react";

// Component Footer của website
const Footer: React.FC = () => {
  return (
    <footer className="flex-shrink-0 bg-gradient-to-r from-blue-900 to-blue-600 dark:bg-gradient-to-r dark:from-[#1a1e3a] dark:to-[#181824] border-t border-slate-200/80 dark:border-slate-700/80 mt-auto shadow-xl">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-[1.16rem] sm:py-[1.55rem] relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="text-xs sm:text-base text-white dark:text-primary-300 font-medium">
              © {new Date().getFullYear()}
              <span
                className="mx-2 font-semibold"
                style={{
                  fontFamily:
                    "'JetBrains Mono', 'Fira Code', 'Source Code Pro', monospace",
                }}
              >
                CNTT K23M
              </span>
              Bản quyền thuộc về @tuanit
            </p>
          </div>
          <div className="flex space-x-8">
            <button
              type="button"
              className="text-xs sm:text-base text-white dark:text-primary-300 opacity-80 cursor-default font-medium"
            >
              Về chúng tôi
            </button>
            <button
              type="button"
              className="text-xs sm:text-base text-white dark:text-primary-300 opacity-80 cursor-default font-medium"
            >
              Hỗ trợ
            </button>
            <button
              type="button"
              className="text-xs sm:text-base text-white dark:text-primary-300 opacity-80 cursor-default font-medium"
            >
              Liên hệ
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
